[
  {
    "code": "GY-BA",
    "name": "Barima-Waini"
  },
  {
    "code": "GY-CU",
    "name": "Cuyuni-Mazaruni"
  },
  {
    "code": "GY-DE",
    "name": "Demerara-Mahaica"
  },
  {
    "code": "GY-EB",
    "name": "East Berbice-Corentyne"
  },
  {
    "code": "GY-ES",
    "name": "Essequibo Islands-West Demerara"
  },
  {
    "code": "GY-MA",
    "name": "Mahaica-Berbice"
  },
  {
    "code": "GY-PM",
    "name": "Pomeroon-Supenaam"
  },
  {
    "code": "GY-PT",
    "name": "Potaro-Siparuni"
  },
  {
    "code": "GY-UD",
    "name": "Upper Demerara-Berbice"
  },
  {
    "code": "GY-UT",
    "name": "Upper Takutu-Upper Essequibo"
  }
]